import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Report {
  id: string;
  name: string;
  description?: string;
  type: string;
  category?: string;
  config: any;
  isPublic: boolean;
  isScheduled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Dashboard {
  id: string;
  name: string;
  description?: string;
  layout: any;
  isPublic: boolean;
  isDefault: boolean;
}

export interface AnalyticsMetrics {
  total: number;
  byStatus: Record<string, number>;
  byPriority: Record<string, number>;
  completed: number;
  inProgress: number;
  blocked: number;
  overdue: number;
  totalStoryPoints: number;
  completedStoryPoints: number;
  completionRate: number;
}

@Injectable({
  providedIn: 'root'
})
export class ReportingService {
  private apiUrl = environment.reportingServiceUrl || 'http://localhost:3006';

  constructor(private http: HttpClient) {}

  getReports(filters?: { type?: string; category?: string; isScheduled?: boolean }): Observable<{ success: boolean; data: Report[] }> {
    let params = new HttpParams();
    if (filters?.type) params = params.set('type', filters.type);
    if (filters?.category) params = params.set('category', filters.category);
    if (filters?.isScheduled !== undefined) params = params.set('isScheduled', filters.isScheduled.toString());
    
    return this.http.get<{ success: boolean; data: Report[] }>(`${this.apiUrl}/api/v1/reports`, { params });
  }

  getDashboards(): Observable<{ success: boolean; data: Dashboard[] }> {
    return this.http.get<{ success: boolean; data: Dashboard[] }>(`${this.apiUrl}/api/v1/dashboards`);
  }

  getTaskMetrics(filters?: {
    projectId?: string;
    teamId?: string;
    departmentId?: string;
    startDate?: string;
    endDate?: string;
  }): Observable<{ success: boolean; data: AnalyticsMetrics }> {
    let params = new HttpParams();
    if (filters?.projectId) params = params.set('projectId', filters.projectId);
    if (filters?.teamId) params = params.set('teamId', filters.teamId);
    if (filters?.departmentId) params = params.set('departmentId', filters.departmentId);
    if (filters?.startDate) params = params.set('startDate', filters.startDate);
    if (filters?.endDate) params = params.set('endDate', filters.endDate);

    return this.http.get<{ success: boolean; data: AnalyticsMetrics }>(`${this.apiUrl}/api/v1/analytics/tasks/metrics`, { params });
  }
}

